interface UserStatusProps {
  banned: boolean;
}

export const UserStatus = ({ banned }: UserStatusProps) => {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ${
        banned
          ? "bg-red-100 text-red-700 dark:bg-red-900/30"
          : "bg-green-100 text-green-700 dark:bg-green-900/30"
      }`}
    >
      {banned ? "Baneado" : "Activo"}
    </span>
  );
};